// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3TG2T","description":"PatientConsentPreview_description__1hA3M"};